import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ReloadDetectionService {
  isPageReload(): boolean {
    const entries = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
    if (entries.length > 0) {
      return entries[0].type === 'reload';
    }
    return performance.navigation?.type === performance.navigation?.TYPE_RELOAD;
  }
}
